import { Col, Heading, Row } from "@george-labs.com/design-system"
import { useTranslation } from "react-i18next"
import { useOffers } from "../../app/hooks"
import "./Offers.css"
import { OfferItem } from "./OfferItem"

const Offers = () => {
  const { t } = useTranslation()
  const offers = useOffers()

  if (!offers?.length) return null

  return (
    <>
      <Heading level={1}>{t("offers.titel")}</Heading>
      <Row className="mb-5">
        {offers?.map((item) => (
          <Col lg={4} key={item.sourceId}>
            <OfferItem item={item} />
          </Col>
        ))}
      </Row>
    </>
  )
}

export default Offers
